import {
  Component,
  inject,
  Injector,
  input,
  runInInjectionContext,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { firstValueFrom } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { PositionHistoryDialogComponent } from '@core/tellent-positions-smart-ui';
import { PositionHistoryDialogData } from '@core/tellent-positions-types';
import { TellentWebComponent } from '@core/tellent-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-position-history-dialog',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TellentPositionHistoryDialogWrapComponent extends DialogWrapComponent<PositionHistoryDialogComponent> {
  private readonly injector = inject(Injector);

  public readonly component = PositionHistoryDialogComponent;
  public readonly config = {
    width: DialogWidth.Medium,
    containerOptions: { fullscreenOnMobile: true },
  };

  public memberGuid = input<string>();
  public canEdit = input<boolean>();
  public memberName = input<string>();
  public memberAvatarUrl = input<string>();

  public override async resolveDialogData(): Promise<PositionHistoryDialogData> {
    const memberGuid = await runInInjectionContext(this.injector, () =>
      firstValueFrom(toObservable(this.memberGuid).pipe(filterDefined)),
    );

    // `canEdit` is meaningful when false, and the host sets every property in one pass without a
    // defined order, so it may still be unset when the guid resolves. Defer a microtask to let the
    // rest of that pass land before reading it — the member details land in the same pass.
    return new Promise(resolve =>
      queueMicrotask(() =>
        resolve({
          memberGuid,
          canEdit: this.canEdit(),
          memberName: this.memberName(),
          memberAvatarUrl: this.memberAvatarUrl(),
        }),
      ),
    );
  }
}

export type TellentPositionHistoryDialogWebComponent = TellentWebComponent<
  TellentPositionHistoryDialogWrapComponent,
  'open' | 'memberGuid' | 'canEdit' | 'memberName' | 'memberAvatarUrl' | 'afterClosed'
>;
